import LoginPassword         from "../../../domain/authentication/LoginPassword";
import CorporationRepository from "../../../domain/corporation/CorporationRepository";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import Error                 from "../../../domain/fundamentals/message/error/Error";
import ErrorMessage          from "../../../domain/fundamentals/message/error/ErrorMessage";
import ErrorRepository       from "../../../domain/fundamentals/message/error/ErrorRepository";
import Errors                from "../../../domain/fundamentals/message/error/Errors";
import ErrorTarget           from "../../../domain/fundamentals/message/error/ErrorTarget";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import CorporationDataSource from "../../../infrastructure/datasource/corporation/CorporationDataSource";
import ErrorDataSource       from "../../../infrastructure/datasource/error/ErrorDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";

class ChangeCorporationPassword {
  constructor(
    private readonly dispatch,
    private readonly corporationRepository: CorporationRepository = new CorporationDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly errorRepository: ErrorRepository = new ErrorDataSource(dispatch),
  ) {}

  public async execute(currentPassword: LoginPassword, newPassword: LoginPassword, confirmPassword: LoginPassword, callback: (value: boolean) => void) {
    this.fetchStatusRepository.start();
    try {
      await this.corporationRepository.changePassword(currentPassword, newPassword, confirmPassword);
      callback(false);
      this.notifyRepository.saveSuccess();
    } catch (e) {
      const list: Error[] = e.response.data.errors.map(error => new Error(new ErrorTarget(error.target), new ErrorMessage(error.message)));
      this.errorRepository.set(new Errors(list));
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default ChangeCorporationPassword;
